import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['indicator', 'select', 'asc', 'desc', 'th']

  connect() {
    this.renderFromDropDown()
  }

  renderFromDropDown() {
    this.clearIndicators()
    for(let th of this.thTargets) {
      if(th.dataset.sort == this.selectTarget.form[this.selectTarget.name].value.split(':')[0]) {
        th.dataset.direction = this.selectTarget.form[this.selectTarget.name].value.split(':')[1]
        this.renderIndicator(th)
      }
    }
  }

  toggle(event) {
    this.selectTarget.form[this.selectTarget.name].value = `${ event.currentTarget.dataset.sort }:${ this.swapDirection(event.currentTarget) }`
    this.clearIndicators()

    this.renderIndicator(event.currentTarget)
    Rails.fire(this.selectTarget.form, 'submit')
  }

  renderIndicator(element) {
    if (element.dataset.caretFlip) {
      element.querySelector("[data-target='table-sort.indicator']").innerHTML = this[`${ this.oppositeDirection(element.dataset.direction) }Target`].innerHTML
    } else {
      element.querySelector("[data-target='table-sort.indicator']").innerHTML = this[`${ element.dataset.direction }Target`].innerHTML
    }
  }

  clearIndicators(){
    for(let indicator of this.indicatorTargets) {
      indicator.innerHTML = ''
    }
  }

  swapDirection(element) {
    element.dataset.direction = this.oppositeDirection(element.dataset.direction)
    return element.dataset.direction
  }

  oppositeDirection(direction) {
    if (direction == 'asc') {
      return 'desc'
    } else {
      return 'asc'
    }
  }
}
